import { render, staticRenderFns } from "./LabFlagsContent.vue?vue&type=template&id=4b5c243e"
import script from "./LabFlagsContent.vue?vue&type=script&lang=js"
export * from "./LabFlagsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports